export function optimizeImage(filename: string, width: number, quality = 80) {
  return `${filename}/m/${width}x0/filters:quality(${quality}):format(webp)`;
}
